import AgentActivity from 'models/agent_activity';
import LoadUserAdmin from 'actions/users/load_user_admin';
import SetAndLogActivity from 'actions/agent_activity/set_and_log_activity';
import changeCurrentLocation from 'actions/lib/change_current_location';
import UsersAdmin from 'models/location/users_admin';

export default class OpenUsersAdmin {
  constructor(context) {
    this.context = context;
  }

  run() {
    if (!this.context.stores.appFeatures.get().isEnabled('teamManagement')) {
      this.context.router.navigateHome();
      return;
    }

    let currentLocation = this.context.stores.currentLocation.get();
    if (!(currentLocation instanceof UsersAdmin)) {
      let locationHistory = this.context.stores.locationHistory.get();
      let previousLocation = locationHistory.getPreviousEntry();
      let nextUsersLocation =
        (locationHistory.isNavigatingBack && previousLocation instanceof UsersAdmin && previousLocation) ||
        UsersAdmin.create();
      changeCurrentLocation(this.context, nextUsersLocation);
    }

    if (
      (!this.context.stores.agentProfiles.isLoading() && !this.context.stores.agentProfiles.count()) ||
      (!this.context.stores.users.isLoading() && !this.context.stores.users.count())
    ) {
      this.context.executeAction(LoadUserAdmin);
    }
    this.context.executeAction(SetAndLogActivity, { type: AgentActivity.Type.USERS_ADMIN });
    this.context.stores.userEditor.remove();
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/users/open_users_admin.js